// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__3kEce","form-field":"Form_form-field__UdSCz","checkbox":"Form_checkbox__3NWv_"};